<div class="intelligence-page">
    <section class="intelligence-hero animate-fade-in-up" aria-label="The Firm">
        <div class="intelligence-hero__container">
            <div class="intelligence-hero__eyebrow">The Firm</div>
            <div class="intelligence-hero__title">
                Architects of <br class="intelligence-hero__title-break" />Intelligence.
            </div>
            <div class="intelligence-hero__copy">
                Rêve is a premier applied AI company delivering automation-led workflows across enterprise applications,
                infrastructure, and data platforms. Founded to radically simplify complex processes, our mission is to
                empower businesses to safely navigate generative AI integration.
            </div>
            <div class="intelligence-hero__copy">
                Our comprehensive approach ensures absolute data sovereignty, ironclad IP security, and rigorous cost
                efficiency. With our dedicated AI engineers, we guarantee rapid, intelligent solutions to your most
                pressing operational bottlenecks.
            </div>

            <blockquote class="intelligence-hero__quote">
                "We envision a future where autonomous agents streamline computation, empowering businesses to deploy
                generative intelligence safely and focus purely on human creativity."
            </blockquote>
        </div>
    </section>

    <section class="values-section" aria-label="Core Values">
        <div class="values-section__container">
            <div class="values-grid">
                <article class="value-card">
                    <div class="value-card__label">Value 01</div>
                    <div class="value-card__title">Innovation</div>
                    <div class="value-card__copy">
                        We continuously push the boundaries of what's possible in enterprise software, deploying
                        cutting-edge agentic AI pipelines.
                    </div>
                </article>

                <article class="value-card">
                    <div class="value-card__label">Value 02</div>
                    <div class="value-card__title">Reliability</div>
                    <div class="value-card__copy">
                        Reliability is our ultimate priority. We engineer cognitive infrastructures that ensure 99.9%
                        uptime and perfectly smooth operations for our clients.
                    </div>
                </article>

                <article class="value-card">
                    <div class="value-card__label">Value 03</div>
                    <div class="value-card__title">Integrity</div>
                    <div class="value-card__copy">
                        Absolute data security and IP sovereignty are the unshakeable cornerstones of our business. We
                        do not risk your corporate data.
                    </div>
                </article>

                <article class="value-card">
                    <div class="value-card__label">Value 04</div>
                    <div class="value-card__title">Collaboration</div>
                    <div class="value-card__copy">
                        We embed ourselves within your teams. We work intimately with clients globally to drive mutual,
                        long-term AI adoption success.
                    </div>
                </article>
            </div>
        </div>
    </section>

    <!-- <section id="contact" class="contact-section" aria-label="Contact Us">
        <div class="contact-section__container">
            <div class="contact-section__grid">
                <div>
                    <div class="contact-section__eyebrow">Connect</div>
                    <div class="contact-section__title">Discover the future of applied AI.</div>
                    <div class="contact-section__copy">
                        Connect with our delivery experts to audit your topology and map your enterprise integration
                        roadmap.
                    </div>
                </div>

                <div class="contact-card">
                    <div class="contact-card__corner" aria-hidden="true"></div>
                    <div class="contact-card__title">Direct Inquiry</div>

                    <div *ngIf="submitted" role="alert" class="contact-card__success animate-fade-in-up">
                        <svg viewBox="0 0 24 24" aria-hidden="true">
                            <polyline points="20 6 9 17 4 12"></polyline>
                        </svg>
                        <div>Request securely logged. Our architecture team will reach out within one business day.
                        </div>
                    </div>

                    <form *ngIf="!submitted" [formGroup]="contactForm" (ngSubmit)="onSubmit()" class="contact-form">
                        <div class="contact-form__field">
                            <input type="text" formControlName="name" placeholder="Full Name" />
                        </div>

                        <div class="contact-form__row">
                            <div class="contact-form__field">
                                <input type="email" formControlName="email" placeholder="Corporate Email" />
                            </div>
                            <div class="contact-form__field">
                                <input type="text" formControlName="company" placeholder="Organization" />
                            </div>
                        </div>

                        <div class="contact-form__field">
                            <textarea rows="3" formControlName="message"
                                placeholder="Brief context of operational challenges..."></textarea>
                        </div>

                        <button type="submit" [disabled]="contactForm.invalid || isSubmitting"
                            class="contact-form__submit">
                            <span *ngIf="!isSubmitting">Transmit Request</span>
                            <span *ngIf="isSubmitting" class="contact-form__submit-loading">
                                <svg viewBox="0 0 24 24" aria-hidden="true">
                                    <circle cx="12" cy="12" r="10"></circle>
                                    <path d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
                                </svg>
                                Encrypting...
                            </span>
                        </button>
                    </form>
                </div>
            </div>
        </div>
    </section> -->
</div>